'use strict';
let templateRendered = '';
const trackingUtils = require('../../modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');
const commonParser = require('../../modules/parsers/dynpack_common');
const parser = require('./parser');
const intersectionObserverProxy = require('od-modules/utils/intersection_observer_proxy');
const Fetcher = require( 'od-modules/utils/fetcher');
const xsellUtils = require('od-modules/utils/xsell.utils');
const logger = require('od-modules/utils/logger');
const {loadAtolWidgets} = require('components/atol_protected/js/main');
const MAX_GALLERY_IMG = 5;
let lastHotelGallery = {};

module.exports = {
    events: {
        'tap @toggleDetails': 'accommodationTrackingDetails',
        'tap .accommodation_toggle_details:not(.selected)': 'onHotelCardClicked',
        'tap .results_gallery_arrow': 'onHotelCardClicked',
        'tap .price_discount_info': 'toggleDiscountBreakdown',
    },
    selectors: {
        toggleDetails: '.accommodation_toggle_details',
        resultBox: '.result_box',
        errorBox: '.xsell_error_box',
        toggleDetailsInfo: '.details_info',
        priceInfo: '.accommodation_price_info',
    },

    init() {
        this.elementsToBeSkipped = 0;
        this.listenTo(this.model, 'loadAccommodationResults', this.update);
        this.io = intersectionObserverProxy((target) => target.classList.remove('lazy'));
    },

    getTemplateBuilder(templateName) {
        templateRendered = templateName;
        return this.getStaticTemplateBuilder('hotel', templateName);
    },
    update() {
        this.options = Odigeo.Utils.parseOptions(this.widget.options);

        const accommodationResults = this.model.get('accommodationResults').slice(0);
        let sliced = [];
        let rest = [];
        if (this.elementsToBeSkipped > 0) {
            sliced = accommodationResults.slice(0, this.elementsToBeSkipped);
            rest = accommodationResults.slice(this.elementsToBeSkipped);
            this.setTemplate(this.$el, this.widget.options.mainTemplate, rest);
            Odigeo.trigger(`${this.widget.id}:refreshResultList`, this.model.get('cheapestPrice'), accommodationResults, sliced);
        } else {
            this.setTemplate(this.$el, this.widget.options.mainTemplate, accommodationResults);
            Odigeo.trigger(`${this.widget.id}:refreshResultList`, this.model.get('cheapestPrice'), accommodationResults, sliced);
            Odigeo.trigger(`${this.widget.id}:refreshScarcityWidget`);
        }
        this.io.observe(this.el.querySelectorAll('.lazy'));
        loadAtolWidgets(this.getListKeys().map((key) => `atol-protected-price-details-${key}`), {hasTooltip: true});
    },

    getListKeys() {
        return this.model.get('accommodationResults').map(({accommodationDeal: {key}}) => key);
    },

    beforeInsertTemplate(data) {
        if (templateRendered === this.options.mainTemplate) {
            return {
                results: parser.getRenderResults(this.model, data),
            };
        } else if (templateRendered === 'cardWrapper') {
            return {
                lazyLoad: true,
                ...parser.parseCardData(data, this.keys),
            };
        }
        return data;
    },
    onHotelCardClicked(evt, _details) {
        const $currentTarget = $(evt.currentTarget);
        const isArrowClicked = $currentTarget.hasClass('prev') || $currentTarget.hasClass('next');

        if (isArrowClicked) {
            evt.stopPropagation();
            this.accommodationGalleryArrowClick($currentTarget);
        } else {
            const details = evt ? $currentTarget.data('details') : _details;
            this.viewAccommodationDetails(details);
        }
    },
    viewAccommodationDetails(details) {
        details.hasRoomSelection = true;
        details.hasRoomInfo = true;
        const accommodationResult = this.model.get('accommodationResults')
            .find((accommodationResult) => accommodationResult.accommodationDeal.key === details.key);
        let params = [details, this.parse(accommodationResult)];

        Odigeo.trigger(`${this.widget.id}:toggleDetails`, ...params);
        this.toggleLinkDetailsStatus(details.panel);
    },
    accommodationGalleryArrowClick($currentTarget) {
        const $hotelImg = $($currentTarget.parents('.od-hotel-card-img'));
        const hotelKey = $currentTarget.data('key');
        const isPrev = $currentTarget.hasClass('prev');
        const imgIndex = $hotelImg.data('imgindex');

        this.trackArrowEvent();
        const newIndex = xsellUtils.getNewGalleryIndex(isPrev, imgIndex, MAX_GALLERY_IMG);
        this.getImageList(hotelKey, newIndex, $hotelImg);
    },
    trackArrowEvent() {
        const action = 'results_list_hotels';
        const label = 'results_list_gallery_click';
        trackingUtils.trackEvent(action, label);
    },
    getImageList(accommodationKey, newIndex, $hotelImg) {
        const url = Odigeo.Settings.getProperty('serviceUrlFormatter')('accommodation/details');
        $hotelImg.addClass('od-accommodation-gallery-image-loading');
        if (!Odigeo._.isEmpty(lastHotelGallery) && lastHotelGallery.key === accommodationKey) {
            this.updateImageSlider($hotelImg, lastHotelGallery.urls, newIndex);
            return Promise.resolve();
        }

        return Fetcher.get(`${url}?key=${accommodationKey}`).json()
            .then(({accommodationImages}) => {
                const imgUrlList = accommodationImages.slice(0, MAX_GALLERY_IMG).map(({url}) => {
                    xsellUtils.loadImg(url);
                    return url;
                });
                if (!Odigeo._.isEmpty(imgUrlList)) {
                    lastHotelGallery = {
                        key: accommodationKey,
                        urls: imgUrlList,
                    };
                    this.updateImageSlider($hotelImg, imgUrlList, newIndex);
                }
            })
            .catch((err) => {
                logger.error(err, `failed to load ${url}?key=${accommodationKey}`);
            });
    },
    updateImageSlider($hotelImg, imageList, newIndex) {
        const noHotelPic = Odigeo.Utils.getImageFromCDN('/onefront/bluestone/OP/no-hotel-pic.png');

        $hotelImg.attr('data-imgindex', newIndex)
            .data('imgindex', newIndex)
            .css('background-image', `url('${imageList[newIndex]}'), url(${noHotelPic})`)
            .removeClass('od-accommodation-gallery-image-loading');
    },
    parse(accommodationResult) {
        return parser.parseCardData(this.getResultData(accommodationResult), this.keys);
    },
    accommodationTrackingDetails(evt) {
        const $link = $(evt.currentTarget);
        const linkData = $link.data();
        const isDetailsOpened = $link.closest(this.$cachedSelectors.resultBox).hasClass('details-opened');

        if (!isDetailsOpened) {
            Odigeo._.isEqual(linkData.details.panel, 'roomInfo')
                ? this.trackSelectRoom(evt)
                : trackingUtils.trackEvent('intermediate_page_hotel_widget', linkData.label);
        }

        evt.stopPropagation();
    },

    getResultData(result, index, firstRoomDealPrice) {
        return parser.getResultData(this.model, {result, index, firstRoomDealPrice});
    },

    toggleLinkDetailsStatus(panel) {
        const selectedClass = 'selected';

        this.$el.find('.details-opened').find(this.$cachedSelectors.toggleDetails)
            .removeClass(selectedClass)
            .filter(commonParser.getSelectorByData({
                detail: 'panel',
                value: panel,
                exclude: this.selectors.toggleDetailsInfo,
            }))
            .addClass(selectedClass);
    },

    trackSelectRoom(evt) {
        const $target = $(evt.currentTarget);
        const $section = $target.parents('.xsell-section');
        const selectedSortingValue = $section.find('.drop_down .active').data('sort');
        const selectedSortingText = parser.getSelectedSortingText(selectedSortingValue);
        const pageNumber = parseInt($section.find('.page_button.selected').text(), 10);
        const pageAggregate = (pageNumber - 1) * 30;
        const hotelNumber = $target.data('index') + pageAggregate + 1;
        const {accommodationDeal, upsellPriceBreakdown, bestDeal, goodValueForMoney} = this.model.get('accommodationResults')[$target.data('index')];
        const hotelProviderId = accommodationDeal.providerId;
        const highlightType = parser.getHighlightedType(bestDeal, goodValueForMoney);
        const discountDeal = parser.getDiscountTrackingLabel(upsellPriceBreakdown.discountPercentage);

        const label = `select_room_clicks_${selectedSortingText}_${hotelNumber}_${hotelProviderId}_${highlightType}_${discountDeal}`;

        trackingUtils.trackEvent('intermediate_page_hotel_widget', label);
        tagManagement.sendEvent('view_rooms');
    },

    showContainer() {
        this.$cachedSelectors.resultBox.removeClass('odf-hidden');
    },

    hideContainer() {
        this.$cachedSelectors.resultBox.addClass('odf-hidden');
    },

    handleError(key, remove) {
        const suffix = Odigeo.AB.isIntermediateModalRoomSelection ? `[data-key="${key}"]` : `.details-opened`;
        const $container = this.$el.find(`${this.selectors.resultBox}`+ suffix);

        this.handleRemoveOrDisableAccommodationResult(remove, $container);
        this.showErrorBox(key);
    },

    handleRemoveOrDisableAccommodationResult(remove, $container) {
        if (!remove) {
            $container.find('.select_room_button').data('disabled', true).addClass('disabled');
            $container.find('.accommodation_toggle_details').data('disabled', true).addClass('disabled')
                .removeClass('accommodation_toggle_details');
            $container.removeClass('details-opened');
            $container.find('.accommodation_details').removeClass('open');
        } else {
            $container.addClass('odf-hidden');
        }
    },

    showErrorBox(accommodationDealKey) {
        const $errorBox = this.$el.find(this.selectors.errorBox + '[data-key="' + accommodationDealKey + '"]');

        this.hideHotelErrors();
        $errorBox.removeClass('odf-hidden');
    },

    hideHotelErrors() {
        this.$cachedSelectors.errorBox.addClass('odf-hidden');
    },

    handleSelectionAccommodationProductError(data) {
        this.$el.find(this.selectors.resultBox + '[data-key="' + data.accommodationDealKey + '"]')
            .find('.select_room_button').trigger(Odigeo.Events.tap);
        Odigeo.trigger(`${this.widget.id}:handleSelectionAccommodationProductError`, data);
    },

    updatePricesAfterRepricing(data) {
        let priceInfoContainer = this.$el.find(this.selectors.priceInfo + '[data-key="' + data.accommodationDealKey + '"]');
        let resultsFragment = document.createDocumentFragment();
        let resultHtml = '';
        const priceInfoTemplate = this.model.get('templates').priceInfo;

        priceInfoContainer.empty();
        Odigeo._.each(this.model.get('accommodationResults'), function(result, index) {
            if (Odigeo._.isEqual(result.accommodationDeal.key, data.accommodationDealKey)) {
                resultHtml = $.parseHTML(priceInfoTemplate(this.getResultData(result, index, data.firstRoomDealPrice)).trim());
                resultsFragment.appendChild(resultHtml[0]);
            }
        }, this);
        priceInfoContainer.append(resultsFragment);
    },

    toggleDiscountBreakdown: Odigeo._.debounce(function(evt) {
        $(evt.target).parent().toggleClass('open');
        evt.stopPropagation();
    }, 500, {leading: true}),
};
